import { useEffect } from "react";
import { trackEvent } from "../lib/analytics";

const FUNDA_TARGETS = {
  funda: "https://www.funda.nl/detail/44486481",
  makelaar: "https://www.carolevandenbogerd.nl/",
};

export default function Redirect({ target }) {
  useEffect(() => {
    const dest = FUNDA_TARGETS[target] || FUNDA_TARGETS.funda;

    // Preserve incoming UTM/query params so they travel to the destination.
    const incoming = new URLSearchParams(window.location.search);
    const destUrl = new URL(dest);
    for (const [k, v] of incoming.entries()) {
      if (!destUrl.searchParams.has(k)) destUrl.searchParams.set(k, v);
    }

    const finalUrl = destUrl.toString();

    trackEvent("outbound_redirect", {
      location: "redirect_page",
      destination: target,
      url: finalUrl,
      source: incoming.get("utm_source") || "direct",
      medium: incoming.get("utm_medium") || "",
      campaign: incoming.get("utm_campaign") || "",
    });

    // Small delay so GA has a chance to fire before navigation
    const t = setTimeout(() => {
      window.location.replace(finalUrl);
    }, 350);
    return () => clearTimeout(t);
  }, [target]);

  return (
    <div
      data-testid="redirect-page"
      className="flex min-h-[100svh] items-center justify-center bg-brand-bg px-6"
    >
      <div className="max-w-md text-center">
        <p className="overline">Even doorverwijzen…</p>
        <h1 className="mt-6 font-serif text-3xl text-brand-ink sm:text-4xl">
          Je wordt doorgestuurd naar{" "}
          <span className="italic">
            {target === "makelaar" ? "de makelaar" : "Funda"}
          </span>
        </h1>
        <p className="mt-4 text-sm text-brand-muted">
          Een ogenblik geduld… Werkt het niet?{" "}
          <a
            href={FUNDA_TARGETS[target] || FUNDA_TARGETS.funda}
            className="border-b border-brand-moss text-brand-moss"
          >
            Klik hier
          </a>
          .
        </p>
      </div>
    </div>
  );
}
